export enum PeriodicidadeReplicarObrigacaoEnum {
	Unica = 0,
	Diaria = 1,
	Semanal = 2,
	Quinzenal = 3,
	Mensal = 4,
	Bimestral = 5,
	Trimestral = 6,
	Quadrimestral = 7,
	Semestral = 8,
	Anual = 9,
	Decendial = 10,
	QuandoAplicavel = 11,
	NA = 12,
}
